var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-sm-12"},[(_vm.posts)?_c('ul',{staticClass:"row"},_vm._l((_vm.posts),function(post,index){return _c('li',{key:index,staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"garden-img-full-width garden-overlay-scale"},[_c('router-link',{attrs:{"to":{
              name: 'SinglePost',
              params: {
                type: _vm.type,
                slug: ("" + (post.slug))
              }
            }}},[_c('img',{attrs:{"src":post.featuredImage,"alt":post.title}})]),_c('div',{staticClass:"garden-overlay"},[_c('div',{staticClass:"garden-button"},[_c('router-link',{attrs:{"to":{
                  name: 'SinglePost',
                  params: {
                    type: _vm.type,
                    slug: ("" + (post.slug))
                  }
                }}},[_vm._v(_vm._s(_vm.$t("readMore")))])],1)])],1),_c('div',{staticClass:"meta"},[_c('ul',[_c('li',[(post.chargerDuProjet)?_c('p',[_c('span',{staticClass:"fa fa-user"}),_vm._v(" "+_vm._s(post.chargerDuProjet)+" ")]):_c('p',[_c('span',{staticClass:"fa fa-user"}),_vm._v(" Afrik Eveil ")])]),_c('li',[_c('p',[_c('span',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.format_date(post.created_at))+" ")])]),_c('li',[_c('p',[_c('span',{staticClass:"fa fa-clock-o"}),_c('timeago',{attrs:{"datetime":post.created_at,"locale":_vm.locale}})],1)])])]),_c('router-link',{staticClass:"garden-hv-child-color-primary",attrs:{"to":{
            name: 'SinglePost',
            params: {
              type: _vm.type,
              slug: ("" + (post.slug))
            }
          }}},[_c('h3',[_vm._v(_vm._s(post.title))])]),_c('p',{domProps:{"innerHTML":_vm._s(post.content.substring(0, 550))}},[_vm._v("....")]),_c('router-link',{staticClass:"btn btn-md readMore",attrs:{"to":{
            name: 'SinglePost',
            params: {
              type: _vm.type,
              slug: ("" + (post.slug))
            }
          }}},[_vm._v(" "+_vm._s(_vm.$t("readMore"))+_vm._s(" ")+" "),_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])],1)])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }